'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);

/**
 * Base class for button.
 *
 * @export
 * @class ButtonBase
 */
var ButtonBase = /*#__PURE__*/_createClass__default["default"](function ButtonBase() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  _classCallCheck__default["default"](this, ButtonBase);
  this.key = options.key || '';
  this.menu = options.menu || [];
  this.color = options.color || '';
  this.disabled = !!options.disabled;
  this.tooltip = options.tooltip || '';
  this.controlType = options.controlType || '';
  this.menuPositionX = options.menuPositionX || 'after';
  this.menuPositionY = options.menuPositionY || 'below';
  this.tooltipPosition = options.tooltipPosition || 'below';
  this.child = options.child;
  this.show = options.show;
  this.checked = options.checked;
});

exports.ButtonBase = ButtonBase;
